export const AuthClassToken = 'AuthClass';
export const AmplifyClassToken = 'AmplifyClass';
export const HubClassToken = 'HubClass';
